import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'es7-object-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { App } from './components/app/app';
import { Provider } from 'react-redux';
import store from './redux/storeData/store';
ReactDOM.render(React.createElement(BrowserRouter, null,
    React.createElement(Provider, { store: store },
        React.createElement(App, null))), document.querySelector('#root'));
